export default __webpack_public_path__ + "static/media/sandeepJha.ad58a94d.webp";